<div class="login">
    <div class="login__bg-layer">
        <div class="login__content">
            <h2>
                <fa-icon [icon]="faUser"></fa-icon> &nbsp; Momstjek er flyttet
            </h2>
            <p class="login__text">
                Du bruger i øjeblikket Momstjek via adressen new.momstjek.dk, som tidligere blev anvendt i forbindelse med en teknisk omlægning.
                Løsningen er nu fuldt tilgængelig på momstjek.dk, og vi beder dig derfor fremover benytte denne adresse.
            </p>
            <p class="login__cta">
                Fortsæt til <a class="login__link" href="https://momstjek.dk">momstjek.dk</a>
            </p>
            <p class="login__text">
                Hvis du har gemt et bogmærke eller en genvej til new.momstjek.dk, anbefaler vi, at du opdaterer det.
            </p>    
        </div>
        <div class="login__logo">
            <img src="../../../../../assets/images/bdo-logo.png" />
            <span>Moms Tjek</span>
        </div>
    </div>
</div>